import _util from '../../utils/';


const attendanceRecordService = {
	syncAttendanceRecord (gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/SyncAttendanceRecord',
            params: gets,
            success: resolve,
            error: reject
        })
    },

	// attendance record
	fetchAttendanceRecord (gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/Get',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    fetchExceptionAttendanceRecord (gets, resolve, reject) {
        _util.request({
            url: '/api/HRExceptionAttendanceRecords/Get',
            params: gets,
            success: resolve,
            error: reject
        })
	},
	updateAttendanceRecord(puts, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceRecords/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		});
	},
    updateSchedule(puts, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/UpdateSchedule',
            method: 'put',
            data: puts,
            success: resolve,
            error: reject
        });
    },
    updateScheduleCustom(puts, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/UpdateScheduleCustom',
            method: 'put',
            data: puts,
            success: resolve,
            error: reject
        });
    },
    // attendance record
    fetchHRAttendanceSchedule( resolve) {
        _util.request({
            url: '/api/HRAttendanceSchedule/Get',
            success: resolve
        })
    },
	importAttendanceRecord(data, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/Import',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        });
    },
    exportAttendanceRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/Export',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceExceptionRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceExceptionRecords/Export',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    downloadTemplate(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/GetImportTemplate',
            params: gets,
            success: resolve,
            error: reject
        });
    },

    // attendance daily record
    selectAttendanceDailyRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceRecordsDailyList',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceDailyRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RecordDailyReportExport',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    // attendance daily record detail
    selectAttendanceDailyRecordDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceRecordsDailyDetails',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceDailyRecordDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RecordDailyReportDetailsExport',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    // attendance monthly record
    selectAttendanceMonthlyRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceRecordsMonthlyList',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceMonthlyRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RecordMonthlyReportExport',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    // attendance monthly record detail
    selectAttendanceMonthlyRecordDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceRecordsMonthlyDetails',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceMonthlyRecordDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RecordMonthlyReportDetailsExport',
            params: gets,
            success: resolve,
            error: reject
        })
    },



    // attendance yearly record
    selectAttendanceYearlyRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceRecordsYearlyList',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceYearlyRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RecordYearlyReportExport',
            params: gets,
            success: resolve,
            error: reject
        })
    },


    // attendance check in and check out record
    selectAttendanceCheckInOutRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceCheckInOutRecords',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    // attendance check in and check out record
    selectAttendanceClockInRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceClockInRecords',
            params: gets,
            success: resolve,
            error: reject
        })
    },

  // attendance  no check in and check out record
  selectAttendanceNoCheckInOutRecord(gets, resolve, reject) {
    _util.request({
        url: '/api/HRAttendanceRecords/AttendanceNoCheckInOutRecords',
        params: gets,
        success: resolve,
        error: reject
    })
},
//未打卡详细信息
selectAttendanceNoCheckInOutRecordDetail(gets, resolve, reject) {
    _util.request({
        url: '/api/HRAttendanceRecords/AttendanceNoCheckInOutRecordsDetail',
        params: gets,
        success: resolve,
        error: reject
    })
},

    exportAttendanceCheckInOutRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/exportCheckInOutRecords',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    exportAttendanceClockInRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/exportClockInRecords',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    // attendance tRelaxation record
    selectRelaxationRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RelaxationList',
            params: gets,
            success: resolve,
            error: reject
        })
    },
        // attendance tRelaxation record
        exportRelaxationRecord(gets, resolve, reject) {
            _util.request({
                url: '/api/HRAttendanceRecords/ExportRelaxationList',
                params: gets,
                success: resolve,
                error: reject
            })
        },
    adjustRelaxation(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AdjustRelaxation',
            method: 'POST',
            data: gets,
            success: resolve,
            error: reject
        })
    },
    // attendance yearly record detail
    selectAttendanceYearlyRecordDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceRecordsYearlyDetails',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    exportAttendanceYearlyRecordDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/RecordYearlyReportDetailsExport',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    getMakeupReason(gets, resolve, reject) {
        _util.request({
            url: '/api/Common/GetSupplementReasonList',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    updateBatchMakeup(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceBatchSupplement',
            method: 'POST',
            data: gets,
            success: resolve,
            error: reject
        })
    },

    updateMakeup(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/AttendanceSupplement',
            method: 'POST',
            data: gets,
            success: resolve,
            error: reject
        })
    },
}


export default attendanceRecordService;




// WEBPACK FOOTER //
// ./src/services/Attendance/attendance-record-service.js